export default __webpack_public_path__ + "images/dcd67c146177a1e0fb6dfd8ed75dcddb.svg";